/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Pick_SomeoneInputs */

const th_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกอย่างน้อยหนึ่งคน`)
};

const en_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose at least one person.`)
};

const ja_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`少なくとも 1 人を選んでください。`)
};

const zh_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`至少选择一个人。`)
};

const es_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige al menos a una persona.`)
};

const pt_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha pelo menos uma pessoa.`)
};

const id_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih setidaknya satu orang.`)
};

const fr_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez au moins une personne.`)
};

const tl_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng kahit isang tao.`)
};

const vi_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất một người.`)
};

const ko_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`적어도 한 사람을 선택하세요.`)
};

const de_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle mindestens eine Person.`)
};

const ru_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите хотя бы одного человека.`)
};

const tr_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En az bir kişi seçin.`)
};

const it_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli almeno una persona.`)
};

const pl_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz przynajmniej jedną osobę.`)
};

const uk_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть щонайменше одну людину.`)
};

const hi_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कम से कम एक व्यक्ति चुनें।`)
};

const ar_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر شخصًا واحدًا على الأقل.`)
};

const ms_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih sekurang-kurangnya seorang.`)
};

const bn_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্তত একজনকে বেছে নিন।`)
};

const zh_tw2_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`至少選擇一個人。`)
};

const zh_hk2_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`至少選擇一個人。`)
};

const ur_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کم از کم ایک شخص چنیں۔`)
};

const fa_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دست‌کم یک نفر را برگزینید.`)
};

const sw_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chagua angalau mtu mmoja.`)
};

const nl_meeting_pick_someone = /** @type {(inputs: Meeting_Pick_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies minstens één persoon.`)
};

/**
* | output |
* | --- |
* | "Choose at least one person." |
*
* @param {Meeting_Pick_SomeoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_pick_someone = /** @type {((inputs?: Meeting_Pick_SomeoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Pick_SomeoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_pick_someone(inputs)
	if (locale === "ja") return ja_meeting_pick_someone(inputs)
	if (locale === "zh") return zh_meeting_pick_someone(inputs)
	if (locale === "es") return es_meeting_pick_someone(inputs)
	if (locale === "pt") return pt_meeting_pick_someone(inputs)
	if (locale === "id") return id_meeting_pick_someone(inputs)
	if (locale === "fr") return fr_meeting_pick_someone(inputs)
	if (locale === "tl") return tl_meeting_pick_someone(inputs)
	if (locale === "vi") return vi_meeting_pick_someone(inputs)
	if (locale === "ko") return ko_meeting_pick_someone(inputs)
	if (locale === "de") return de_meeting_pick_someone(inputs)
	if (locale === "ru") return ru_meeting_pick_someone(inputs)
	if (locale === "tr") return tr_meeting_pick_someone(inputs)
	if (locale === "it") return it_meeting_pick_someone(inputs)
	if (locale === "pl") return pl_meeting_pick_someone(inputs)
	if (locale === "uk") return uk_meeting_pick_someone(inputs)
	if (locale === "hi") return hi_meeting_pick_someone(inputs)
	if (locale === "ar") return ar_meeting_pick_someone(inputs)
	if (locale === "ms") return ms_meeting_pick_someone(inputs)
	if (locale === "bn") return bn_meeting_pick_someone(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_pick_someone(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_pick_someone(inputs)
	if (locale === "ur") return ur_meeting_pick_someone(inputs)
	if (locale === "fa") return fa_meeting_pick_someone(inputs)
	if (locale === "sw") return sw_meeting_pick_someone(inputs)
	if (locale === "nl") return nl_meeting_pick_someone(inputs)
	return en_meeting_pick_someone(inputs)
});